<template>
  <the-animations />
</template>